goog.provide('el8.ptdata.model.attachment');
goog.provide('el8.ptdata.model.externalReportAttachment');
goog.require('el8.model.base');


(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty("contentType");
    _class.addStringProperty("originalFilename");
    _class.addStringProperty("downloadUrl");
    _class.addStringProperty("type");  // possible values are imported_file and document_file
    _class.addIntProperty("printableId");

    el8.ptdata.model.attachment = function(spec) { return new _class(spec); };

})();


(function() {

    var _class = function(spec) { this.populate(spec); };
    
    _class.inheritsFrom(el8.ptdata.model.attachment);
    
    _class.prototype.getReferencedUrl = function() {
        if (!this.content) {
            this.getContent();
        }
        return this.content.referenced_url;
    }
    
    _class.prototype.asSoyMap = function(loadContent) {
        var mapped = el8_Entity.prototype.asSoyMap.call(this, {});

        if (loadContent) {
            mapped['referenced_url'] = this.getReferencedUrl();
            mapped['summary'] = this.getSummary();
        }
        return mapped;

    };
    
    _class.prototype.getSummary = function() {
        if (!this.content) {
            this.getContent();
        }
        return this.content.summary;
    }
    
    _class.prototype.getContent = function() {
        var that = this;
        var content = null;
        $.el8_ajax({
            type: "GET",
            async: false,
            url: that.getDownloadUrl(),
            success: function(data) {
                that.content = data;
            }
        });
        return that.content;
    }
    
    el8.ptdata.model.externalReportAttachment = function(spec) { return new _class(spec); };

})();